import { render, staticRenderFns } from "./TrainingsPage.vue?vue&type=template&id=33e9fbe4&scoped=true"
import script from "./TrainingsPage.vue?vue&type=script&lang=js"
export * from "./TrainingsPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingsPage.vue?vue&type=style&index=0&id=33e9fbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9fbe4",
  null
  
)

export default component.exports